import React from "react";
import { AddressAutofill } from "@mapbox/search-js-react";
import { useStateContext } from "../contexts/ContextProvider";
import { statesArray, homeTypes } from "../data/dummyData";

const AddressForm = (props) => {
  const { edit } = props;
  const { address, setAddress, handleAddress, errorAnimation } =
    useStateContext();

  const token = process.env.REACT_APP_MAPBOX_TOKEN;

  const getCoordinates = async (event) => {
    if (event.features[0] !== null) {
      const longitude = await event.features[0].geometry.coordinates[0];
      const latitude = await event.features[0].geometry.coordinates[1];
      const neighborhood =
        (await event.features[0].properties.neighborhood) || "";
      setAddress((prevState) => ({
        ...prevState,
        latitude: `${latitude}`,
        longitude: `${longitude}`,
        neighborhood,
      }));
    }
  };

  return (
    <form className="grid mt-5">
      <AddressAutofill
        accessToken={token}
        options={{ streets: false, country: "US", proximity: "ip" }}
        onRetrieve={getCoordinates}
        tabIndex={-1}
      >
        <label className={`grid ${errorAnimation.street}`}>
          Street Address:
          <input
            id="street"
            name="street"
            type="text"
            value={address.street}
            placeholder="Street"
            autoComplete="address-line1"
            className={`border-gray-400 rounded-md border-1 p-1 ${errorAnimation.street}`}
            onChange={handleAddress}
          />
        </label>
      </AddressAutofill>
      <label className="grid">
        Address Line 2:
        <input
          id="street2"
          name="street2"
          type="text"
          value={address.street2 || ""}
          placeholder="Apt / Unit / Suite"
          autoComplete="address-line2"
          className="border-gray-400 rounded-md border-1 p-1"
          onChange={handleAddress}
        />
      </label>
      <div className="flex">
        <label className={`grid ${errorAnimation.city}`}>
          City:
          <input
            id="city"
            name="city"
            type="text"
            value={address.city}
            placeholder="City"
            autoComplete="address-level2"
            className={`border-gray-400 rounded-s-md border-1 p-1 ${errorAnimation.city}`}
            onChange={handleAddress}
          />
        </label>
        <label className={`grid ${errorAnimation.state}`}>
          State:
          <select
            id="state"
            name="state"
            className={`border-gray-400 rounded-e-md border-1 p-1 ${errorAnimation.state}`}
            autoComplete="address-level1"
            value={address.state}
            onChange={handleAddress}
          >
            <option disabled>--</option>
            {statesArray.map((item, index) => {
              return <option key={item.id}>{item.abbr.toUpperCase()}</option>;
            })}
          </select>
        </label>
      </div>
      <label className={`grid ${errorAnimation.zipCode}`}>
        Zip Code:
        <input
          id="zipCode"
          name="zipCode"
          type="tel"
          maxLength={5}
          value={address.zipCode}
          placeholder="Zip Code"
          autoComplete="postal-code"
          className={`border-gray-400 rounded-md border-1 p-1 ${errorAnimation.zipCode}`}
          onChange={handleAddress}
        />
      </label>

      {edit && (
        <>
          <div className="grid justify-items-center text-xl mt-10">
            Edit Property Type:
          </div>
          <div className="grid justify-items-center">
            <label className={`flex mt-5 ${errorAnimation.state}`}>
              <select
                id="home-type"
                name="homeType"
                className={`border-gray-400 rounded-md border-1 ${errorAnimation.state}`}
                value={address.homeType}
                onChange={handleAddress}
              >
                <option disabled>--</option>
                {homeTypes.map((item, index) => {
                  return (
                    <option key={item.id} value={item.name}>
                      {item.name[0].toUpperCase() + item.name.slice(1)}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
        </>
      )}
    </form>
  );
};

export default AddressForm;
